import routes from './routes';
import { SetRoutes } from 'components';

const ContactRolesMainPage = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ContactRolesMainPage;
